module.exports = __webpack_public_path__ + "static/media/brecka - android.ff70bb05.png";